import { Component } from "react";
import notification_bell from '../../img/bell.svg'
import avatar from '../../img/avatar.svg'
import { Link } from "react-router-dom";
import { API_URL } from "../../constant/API_Settings"
import { WEB_URL } from "../../constant/API_Settings"
import { withRouter } from 'react-router-dom';
import { getStoredPermissions, savePermissions } from "../../utils/permissions";
import { isPlatformSuperAdmin } from "../../utils/platformAuth";
import HelpSupportWidget from "../support/HelpSupportWidget";
import HeaderInboxMenu from "../Notification/HeaderInboxMenu";
import OperationalDateChip from "../layouts/OperationalDateChip";
import downloadimage from '../../img/download.png';
import { markReportNotificationRead, excludeLocallyReadDownloads, REPORT_DOWNLOADS_REFRESH_EVENT } from "../../utils/reportFormat";

class LoginHeaderOperational extends Component {
  constructor(props) 
  {
   

    super(props)

    this.state =
    {
      // inputValues={},
       op_date: '',
      'profile_name': localStorage.getItem("PROFILE_NAME"),
      // 'op_date': localStorage.getItem("op_date"),
      curTime: new Date().toLocaleString(),
      userId: '',
      noti_count: '',
      permissions: getStoredPermissions(),
      set_notification: [],
      set_download: [],
      noti_count_state: '',
      is_platform_super_admin: false,

    }
    this.readDownloadIds = new Set();
    this.readBellIds = new Set();
    var time = this.state.curTime.split(',')
    var time1 = time[1]
    localStorage.setItem('time', time1);

  }

  /*componentDidMount() {
    
    this.check_meta_date()
    this.get_notification()
      setInterval(async () => {
        this.get_notification()
      }, 30000);

  }*/
 componentDidMount() {
    this._isMounted = true;
    
    this.check_meta_date()
    this.get_notification()
    window.addEventListener(REPORT_DOWNLOADS_REFRESH_EVENT, this.get_notification);

     const userId = localStorage.getItem("USER_ID");

    if (userId) {
        /*echo.private(`App.Models.User.${userId}`)
            .listen("ForceLogout", () => {
                localStorage.clear();
                this.props.history.push("/login");
            });*/
    }

     // Pages that should NOT call notification every 30s
    const noIntervalPages = [
      "/nozzle-closing",
      "/credit-sales",
      "/fleet-card-sales",
      "/recoup",
      "/card-sales",
      "/cashpayment",
      "/bag-collection",
      "/ReceiptVoucher",
      "/closepayment",
      "/nonfuel-product-direct-employee",
      "/gas_cylinder_sales_empoyee",
      "/oil-barrel-sales-employee",
      "/expense",
      "/mla-coupon-sales"
    ];

    const currentPath = this.props.location.pathname;
    // Only set interval if page NOT in the restricted list
    if (!noIntervalPages.includes(currentPath)) {
      this.interval = setInterval(() => {
        this.get_notification();
      }, 20000);
    }



  }
  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener(REPORT_DOWNLOADS_REFRESH_EVENT, this.get_notification);
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  
  /*componentWillUnmount() {
    const userId = localStorage.getItem("USER_ID");

    if (userId) {
      //vsdecho.leave(`private-App.Models.User.${userId}`);
      //echo.private(`App.Models.User.${userId}`).stopListening("ForceLogout");
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
  }*/
  check_meta_date = () => {
    const token = localStorage.getItem("AUTH_TOKEN");
    if (!token) {
      return;
    }

    const adminPaths = [
      '/admin_dashboard',
      '/admin-pumps-details',
      '/pump_name',
      '/admin-user-management',
      '/admin-role-list',
      '/admin-subscription-management',
      '/admin-payment-management',
      '/admin-invoice-settings',
      '/admin-alerts',
      '/admin-analytics',
      '/admin-business-insights',
      '/admin-audit-log',
      '/admin-master-settings',
      '/admin-support',
      '/admin-support-tickets',
      '/admin-ledger-errors',
      '/admin-tank-stock-errors',
      '/permission',
    ];
    const path = this.props.location?.pathname || '';
    if (adminPaths.includes(path) || path.startsWith('/admin-pump/') || path.startsWith('/admin-ledger-errors') || path.startsWith('/admin-tank-stock-errors')) {
      return;
    }

    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + token,
        "Accept": "application/json"

      }
    };
    fetch(`${API_URL}/check_meta_date`, requestOptions)
      .then(response => {
        if (!response.ok) {
          return response.json().then((data) => {
            if (data.message === "Unauthenticated.") {
              localStorage.removeItem("AUTH_TOKEN");
              localStorage.removeItem("ROLE_ID");
              localStorage.clear();
              this.props.history.push("/login");
            }
            return data;
          });
        }
        return response.json();
      })
      .then(responseData => {
        if (!this._isMounted || !responseData) return responseData;
        this.setState({
          op_date: responseData.op_date,
          userId: responseData.userId,
          role_id: responseData.role_id,
          owner: responseData.owner,
          is_platform_super_admin: isPlatformSuperAdmin(responseData),
        })
        localStorage.setItem('m_op_date', responseData.op_date);
        return responseData;
      })
      .catch(e => {
      });

  }


  isAdminScreen = () => {
    const adminPaths = [
      '/admin_dashboard',
      '/admin-pumps-details',
      '/pump_name',
      '/admin-user-management',
      '/admin-role-list',
      '/admin-subscription-management',
      '/admin-payment-management',
      '/admin-invoice-settings',
      '/admin-alerts',
      '/admin-analytics',
      '/admin-business-insights',
      '/admin-audit-log',
      '/admin-master-settings',
      '/admin-support',
      '/admin-support-tickets',
      '/admin-ledger-errors',
      '/admin-tank-stock-errors',
      '/permission',
    ];
    const path = this.props.location?.pathname || '';
    return adminPaths.includes(path) || path.startsWith('/admin-pump/') || path.startsWith('/admin-ledger-errors') || path.startsWith('/admin-tank-stock-errors');
  }

  approved_notification({ task_id }) {


    const requestOptions = {
      method: 'post',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"

      },
      body: JSON.stringify({
        task_id: task_id,


      })
    };
    fetch(API_URL + "/notifications_done", requestOptions)
      .then(response => { return response.json(); })
      .then(responseData => {
      })
      .catch(e => {
      });

  }



  get_notification = () => {

    const requestOptions = {
      method: 'get',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Accept": "application/json"
      }
    };
    fetch(API_URL + "/getnotification", requestOptions)
      .then(response => {
        return response.json();
      })
      .then(responseData => {
        if (!this._isMounted) return responseData;
        const downloads = excludeLocallyReadDownloads(
          responseData?.data_statement,
          responseData?.noti_count_statement,
          this.readDownloadIds
        );
        const bells = excludeLocallyReadDownloads(
          responseData?.data,
          responseData?.noti_count,
          this.readBellIds
        );
        const normalizedPermissions = savePermissions(responseData?.permissions || []);
        this.setState({
          set_notification: bells.items,
          noti_count: bells.count,
          set_download: downloads.items,
          noti_count_state: downloads.count,
          permissions: normalizedPermissions,
        });
        if (responseData?.operation_date) {
          this.setState({ op_date: responseData.operation_date });
        }
        if (responseData.message == "Unauthenticated.") {
          localStorage.removeItem("AUTH_TOKEN");
          localStorage.removeItem("ROLE_ID");
          localStorage.clear();
          this.props.history.push("/login");
        }
        return responseData;
      })
      .catch(e => {
      });

  }

  markInboxRead = (item, idSet, listKey, countKey) => {
    if (!item?.id || item.queue_status === 'queued') {
      return;
    }
    if (idSet.has(item.id)) {
      return;
    }
    idSet.add(item.id);
    this.setState((prev) => {
      const next = excludeLocallyReadDownloads(
        prev[listKey],
        prev[countKey],
        idSet
      );
      return {
        [listKey]: next.items,
        [countKey]: next.count,
      };
    });
    markReportNotificationRead(item.id);
  }

  handleReportDownloadHover = (item) => {
    this.markInboxRead(item, this.readDownloadIds, 'set_download', 'noti_count_state');
  }

  handleBellHover = (item) => {
    this.markInboxRead(item, this.readBellIds, 'set_notification', 'noti_count');
  }

  handleBellClick = (event, item) => {
    if (!item?.url) {
      event.preventDefault();
    }
    this.handleBellHover(item);
  }

  handleReportDownloadClick = async (event, item) => {
    if (!item) {
      return;
    }
    if (item.queue_status === 'queued' || !item.url) {
      event.preventDefault();
      if (this.props.history) {
        this.props.history.push('/report-downloads');
      }
      if (item.queue_status === 'failed') {
        this.handleReportDownloadHover(item);
      }
      return;
    }
    this.handleReportDownloadHover(item);
  }


  render() {

    return (<div className=""><nav className="navbar navbar-expand-lg navbar-light bg-light top-menu ">
      <button className="navbar-toggler d-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="container-fluid">
        <h3 className="navbar-head" href="#">{this.props.page_title}</h3>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">

          <ul className="navbar-nav ms-auto mb-1 mb-lg-1">
            <li className="nav-item  ">
              <p className="mt-3 me-3">

                {/* <i className="fa fa-clock-o me-2" aria-hidden="true"></i>  {localStorage.getItem("time")} */}





              </p>

            </li>
            <OperationalDateChip value={this.state.op_date} />
            {!this.isAdminScreen() && !this.state.is_platform_super_admin && (
              <li className="nav-item d-flex align-items-center">
                <HelpSupportWidget />
              </li>
            )}
            <HeaderInboxMenu
              icon={notification_bell}
              iconAlt="Notifications"
              title="Notifications"
              items={this.state.set_notification || []}
              count={this.state.noti_count}
              emptyText="No unread notifications."
              viewAllTo="/all_notifications/1"
              viewAllLabel="View all notifications"
              onOpenItem={this.handleBellClick}
              onMarkRead={this.handleBellHover}
            />
            <HeaderInboxMenu
              icon={downloadimage}
              iconAlt="Report downloads"
              title="Downloads"
              items={this.state.set_download || []}
              count={this.state.noti_count_state}
              emptyText="No unread reports."
              viewAllTo="/report-downloads"
              viewAllLabel="View all reports"
              onOpenItem={this.handleReportDownloadClick}
              onMarkRead={this.handleReportDownloadHover}
              showStatus
            />
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle user-head" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <img className="img-profile rounded-circle" src={avatar} />{this.state.profile_name}<span><i className="fa fa-angle-down font-weight-bolder" aria-hidden="true"></i></span>
              </a>

              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
               
                {/* {this.state.role_id != 1 ?
                  <>{this.state.permissions.includes("All Reports") == true ?
                    <li><a class="dropdown-item" href="#"><i class="fa fa-wrench me-2" aria-hidden="true"></i>Report &raquo; </a>
                      <ul class="submenu dropdown-menu">
                        <li><Link class="dropdown-item" to="/daily-transaction-sheet">Daily Transaction</Link></li>
                        {this.state.owner == "owner" ?
                          <li><Link class="dropdown-item" to="/stock-gain-loss">Stock Gain/Loss</Link></li>
                          : ''}
                        <li><Link to="op-simplified-balance-sheet"><a class="dropdown-item" href="#">Balance sheet Summary </a></Link>
                         
                        </li>
                        <li><Link to="/op-worksheet"><a class="dropdown-item" href="#">WorkSheet</a></Link></li>
                       
                        <li><Link class="dropdown-item" to="/daily-transaction-sheet">Reports</Link></li>

                      </ul>
                    </li> : ''} </>
                  : ''}
                <li><hr className="dropdown-divider" /></li> */}
                <li><Link className="dropdown-item" to="/logout"><i className="fa fa-sign-out me-2" aria-hidden="true"></i>Logout</Link></li>
              </ul>
            </li>

          </ul>

        </div>
      </div>
    </nav>
    </div>

    )
  }

}

export default withRouter(LoginHeaderOperational)
